import { computed, toRef } from 'vue'

export default function useConditionalSpacing(
  prevComponent,
  nextComponent,
  inlineComponents = []
) {
  const prevComponentRef = toRef(prevComponent, 'value')
  const nextComponentRef = toRef(nextComponent, 'value')

  return computed(() => {
    if (!inlineComponents.length) {
      inlineComponents = [
        'custom_text',
        'custom_image_or_video',
        'text_and_image_or_video',
        'testimonial',
        'downloads',
        'links',
      ]
    }

    // if the PREVIOUS and NEXT component are both inline components
    if (
      inlineComponents.includes(prevComponentRef.value) &&
      inlineComponents.includes(nextComponentRef.value)
    ) {
      return 'inline_text_top_bottom'
    }

    // if the PREVIOUS component is an inline component
    if (inlineComponents.includes(prevComponentRef.value)) {
      return 'inline_text_top'
    }

    // if the NEXT component is an inline component
    if (inlineComponents.includes(nextComponentRef.value)) {
      return 'inline_text_bottom'
    }

    return 'default'
  })
}
